import React, { useState } from 'react';
import { toast } from 'react-toastify';
import './ApiTester.css';

// 🎯 Importar todos los servicios API
import * as controlPanelApi from '../../services/controlPanelApi';
import * as categoriesApi from '../../services/categoriesApi';
import * as usersApi from '../../services/usersApi';
import * as providersApi from '../../services/providersApi';
import * as migrationApi from '../../services/migrationApi';
import * as locationsApi from '../../services/locationsApi';

// 📋 Configuración de endpoints GET disponibles
const API_ENDPOINTS = [
    // Control Panel API
    {
        name: 'Obtener Sugerencias',
        service: 'controlPanelApi',
        method: 'getSuggestions',
        description: 'Lista todas las sugerencias enviadas por usuarios',
        params: []
    },
    {
        name: 'Sugerencias No Vistas',
        service: 'controlPanelApi',
        method: 'getUnseenSuggestions',
        description: 'Lista sugerencias que aún no han sido revisadas',
        params: []
    },
    {
        name: 'Contar Sugerencias',
        service: 'controlPanelApi',
        method: 'countSuggestions',
        description: 'Cuenta el total de sugerencias',
        params: []
    },
    {
        name: 'Obtener Proveedor de Servicios',
        service: 'controlPanelApi',
        method: 'getServiceProvider',
        description: 'Obtiene un proveedor de servicios por username',
        params: [{ name: 'username', type: 'text', placeholder: 'ej: juan_plomero' }]
    },
    {
        name: 'Obtener Proveedor de Productos',
        service: 'controlPanelApi',
        method: 'getProductsProvider',
        description: 'Obtiene un proveedor de productos por username',
        params: [{ name: 'username', type: 'text', placeholder: 'ej: tienda_electronica' }]
    },

    // Categories API
    {
        name: 'Obtener Categorías por Tipo',
        service: 'categoriesApi',
        method: 'getCategories',
        description: 'Lista categorías filtradas por tipo y ubicación',
        params: [
            { name: 'type', type: 'select', options: ['service', 'products'], placeholder: 'Tipo' },
            { name: 'location', type: 'text', placeholder: 'ej: La Plata' }
        ]
    },
    {
        name: 'Obtener Todas las Categorías',
        service: 'categoriesApi',
        method: 'getAllCategories',
        description: 'Lista todas las categorías (servicios y productos)',
        params: [{ name: 'location', type: 'text', placeholder: 'ej: La Plata' }]
    },
    {
        name: 'Obtener Categoría Específica',
        service: 'categoriesApi',
        method: 'getCategory',
        description: 'Obtiene detalles de una categoría específica',
        params: [
            { name: 'type', type: 'select', options: ['service', 'products'], placeholder: 'Tipo' },
            { name: 'name', type: 'text', placeholder: 'ej: plomeria' }
        ]
    },
    {
        name: 'Resultados de Búsqueda',
        service: 'categoriesApi',
        method: 'getSearchResults',
        description: 'Obtiene resultados de búsqueda de categorías',
        params: []
    },
    {
        name: 'Listar Todas las Categorías',
        service: 'categoriesApi',
        method: 'listCategories',
        description: 'Lista todas las categorías sin filtros',
        params: []
    },
    {
        name: 'Estadísticas de Categoría',
        service: 'categoriesApi',
        method: 'getCategoryStats',
        description: 'Obtiene estadísticas de vistas de una categoría',
        params: [{ name: 'categoryId', type: 'text', placeholder: 'ID de la categoría' }]
    },
    {
        name: 'Categorías Nombre y Tipo',
        service: 'categoriesApi',
        method: 'getCategoriesNameType',
        description: 'Obtiene todas las categorías en formato simplificado (label, name, type)',
        params: []
    },

    // Users API
    {
        name: 'Obtener Info de Usuario',
        service: 'usersApi',
        method: 'getUserInfo',
        description: 'Obtiene información de un usuario por email',
        params: [{ name: 'email', type: 'text', placeholder: 'email@ejemplo.com' }]
    },
    {
        name: 'Obtener Usuario Logueado',
        service: 'usersApi',
        method: 'getLoggedUser',
        description: 'Obtiene información del usuario actualmente logueado',
        params: []
    },
    {
        name: 'Contar Usuarios',
        service: 'usersApi',
        method: 'countUsers',
        description: 'Cuenta el total de usuarios registrados',
        params: []
    },
    {
        name: 'Listar Todos los Usuarios',
        service: 'usersApi',
        method: 'listUsers',
        description: 'Lista todos los usuarios del sistema',
        params: []
    },
    {
        name: 'Obtener Notificaciones',
        service: 'usersApi',
        method: 'getNotifications',
        description: 'Obtiene notificaciones del usuario con paginación',
        params: [
            { name: 'pagesize', type: 'number', placeholder: '10', defaultValue: 10 },
            { name: 'lastDocumentId', type: 'text', placeholder: 'ID del último documento (opcional)' }
        ]
    },
    {
        name: 'Notificaciones No Leídas',
        service: 'usersApi',
        method: 'getUnreadNotifications',
        description: 'Obtiene notificaciones no leídas',
        params: [
            { name: 'pagesize', type: 'number', placeholder: '10', defaultValue: 10 },
            { name: 'lastDocumentId', type: 'text', placeholder: 'ID del último documento (opcional)' }
        ]
    },
    {
        name: 'Notificaciones No Vistas',
        service: 'usersApi',
        method: 'getUnseenNotifications',
        description: 'Obtiene notificaciones no vistas',
        params: [
            { name: 'pagesize', type: 'number', placeholder: '5', defaultValue: 5 },
            { name: 'lastDocumentId', type: 'text', placeholder: 'ID del último documento (opcional)' }
        ]
    },

    // Providers API
    {
        name: 'Obtener Proveedores con Filtros',
        service: 'providersApi',
        method: 'getProviders',
        description: 'Obtiene proveedores filtrados por ubicación, categoría, keywords, etc.',
        params: [
            {
                name: 'filters',
                type: 'json',
                placeholder: '{"location":"La Plata","categoryName":"plomeria","keywords":[],"subcategory":"","hasCertificates":null}',
                defaultValue: { location: 'La Plata', categoryName: '', keywords: [], subcategory: '', hasCertificates: null }
            },
            { name: 'providerType', type: 'select', options: ['service', 'products'], placeholder: 'Tipo de proveedor' },
            { name: 'pageSize', type: 'number', placeholder: '12', defaultValue: 12 },
            { name: 'lastDocumentId', type: 'text', placeholder: 'ID del último documento (opcional)' }
        ]
    },
    {
        name: 'Verificar Username Disponible',
        service: 'providersApi',
        method: 'usernameAvailable',
        description: 'Verifica si un username está disponible',
        params: [{ name: 'providerId', type: 'text', placeholder: 'username a verificar' }]
    },
    {
        name: 'Obtener Perfil de Proveedor',
        service: 'providersApi',
        method: 'getProviderProfile',
        description: 'Obtiene el perfil público de un proveedor',
        params: [{ name: 'providerId', type: 'text', placeholder: 'username del proveedor' }]
    },
    {
        name: 'Obtener Proveedor para Edición',
        service: 'providersApi',
        method: 'getProviderForEdit',
        description: 'Obtiene datos completos del proveedor para editar',
        params: [{ name: 'providerId', type: 'text', placeholder: 'username del proveedor' }]
    },
    {
        name: 'Obtener Proveedor Completo',
        service: 'providersApi',
        method: 'getProviderComp',
        description: 'Obtiene información completa del proveedor',
        params: [{ name: 'providerId', type: 'text', placeholder: 'username del proveedor' }]
    },
    {
        name: 'Listar Proveedores Inactivos',
        service: 'providersApi',
        method: 'getInactiveProviders',
        description: 'Lista todos los proveedores inactivos',
        params: []
    },
    {
        name: 'Estadísticas de Proveedor',
        service: 'providersApi',
        method: 'getProviderStats',
        description: 'Obtiene estadísticas de vistas y clicks de un proveedor',
        params: [{ name: 'providerId', type: 'text', placeholder: 'username del proveedor' }]
    },

    // Migration API
    {
        name: 'Estado de Migración',
        service: 'migrationApi',
        method: 'getMigrationStatus',
        description: 'Obtiene el estado actual de las migraciones',
        params: []
    },
    {
        name: 'Resumen de Migración',
        service: 'migrationApi',
        method: 'getMigrationSummary',
        description: 'Obtiene un resumen de todas las migraciones',
        params: []
    },
    {
        name: 'Verificar Estado de Categorías',
        service: 'migrationApi',
        method: 'checkCategoriesStatus',
        description: 'Verifica el estado de migración de categorías',
        params: []
    },
    {
        name: 'Estadísticas de Proveedores (Migración)',
        service: 'migrationApi',
        method: 'getProvidersStats',
        description: 'Obtiene estadísticas de todos los proveedores para migración',
        params: []
    },

    // Locations API
    {
        name: 'Obtener Todas las Ubicaciones',
        service: 'locationsApi',
        method: 'getLocations',
        description: 'Lista todas las ubicaciones disponibles',
        params: []
    },
    {
        name: 'Listar Nombres de Ubicaciones',
        service: 'locationsApi',
        method: 'listLocationNames',
        description: 'Lista solo los nombres de las ubicaciones',
        params: []
    },
    {
        name: 'Obtener Ubicación por Nombre',
        service: 'locationsApi',
        method: 'getLocationByName',
        description: 'Obtiene detalles de una ubicación específica',
        params: [{ name: 'name', type: 'text', placeholder: 'ej: La Plata' }]
    },
    {
        name: 'Ubicaciones por Categoría',
        service: 'locationsApi',
        method: 'getLocationsByCategory',
        description: 'Lista ubicaciones que tienen proveedores de una categoría',
        params: [
            { name: 'type', type: 'select', options: ['service', 'products'], placeholder: 'Tipo' },
            { name: 'name', type: 'text', placeholder: 'ej: plomeria' }
        ]
    },
    {
        name: 'Contar Ubicaciones',
        service: 'locationsApi',
        method: 'countLocations',
        description: 'Cuenta el total de ubicaciones',
        params: []
    }
];

// Mapeo de servicios
const API_SERVICES = {
    controlPanelApi,
    categoriesApi,
    usersApi,
    providersApi,
    migrationApi,
    locationsApi
};

const ApiTester = () => {
    const [selectedEndpoint, setSelectedEndpoint] = useState(null);
    const [paramValues, setParamValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    // Filtrar endpoints por búsqueda
    const filteredEndpoints = API_ENDPOINTS.filter(endpoint =>
        endpoint.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        endpoint.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        endpoint.service.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleEndpointSelect = (endpoint) => {
        setSelectedEndpoint(endpoint);
        setResponse(null);
        setError(null);

        // Inicializar valores de parámetros con valores por defecto
        const initialParams = {};
        endpoint.params.forEach(param => {
            if (param.defaultValue !== undefined) {
                // Si es tipo JSON y el valor por defecto es un objeto, convertirlo a string
                if (param.type === 'json' && typeof param.defaultValue === 'object') {
                    initialParams[param.name] = JSON.stringify(param.defaultValue, null, 2);
                } else {
                    initialParams[param.name] = param.defaultValue;
                }
            } else {
                initialParams[param.name] = '';
            }
        });
        setParamValues(initialParams);
    };

    const handleParamChange = (paramName, value) => {
        setParamValues(prev => ({
            ...prev,
            [paramName]: value
        }));
    };

    const parseParamValue = (param, value) => {
        // Si es tipo JSON, intentar parsear
        if (param.type === 'json') {
            try {
                // Si es un objeto (defaultValue), devolverlo tal cual
                if (typeof value === 'object' && value !== null) {
                    return value;
                }
                // Si es string, intentar parsear
                if (typeof value === 'string' && value.trim() !== '') {
                    return JSON.parse(value);
                }
                // Si está vacío, usar defaultValue
                return param.defaultValue || {};
            } catch (e) {
                console.warn('Error parseando JSON:', e);
                return param.defaultValue || {};
            }
        }

        // Convertir a número si es necesario
        if (param.type === 'number' && value !== '') {
            return Number(value);
        }

        // Si está vacío y no es obligatorio, usar null o undefined
        if (value === '' || value === null) {
            return param.defaultValue !== undefined ? param.defaultValue : null;
        }

        return value;
    };

    const executeEndpoint = async () => {
        if (!selectedEndpoint) return;

        setLoading(true);
        setResponse(null);
        setError(null);

        try {
            const service = API_SERVICES[selectedEndpoint.service];
            const method = service[selectedEndpoint.method];

            if (!method) {
                throw new Error(`Método ${selectedEndpoint.method} no encontrado en ${selectedEndpoint.service}`);
            }

            // Preparar parámetros
            const params = selectedEndpoint.params.map(param => {
                const value = paramValues[param.name];
                return parseParamValue(param, value);
            }).filter(param => param !== null && param !== ''); // Filtrar valores vacíos

            // Ejecutar el método
            console.log('🚀 Ejecutando:', selectedEndpoint.method, 'con parámetros:', params);
            const result = await method(...params);

            setResponse(result);
            toast.success('✅ Petición ejecutada correctamente');
        } catch (err) {
            console.error('❌ Error:', err);
            setError({
                message: err.message || 'Error desconocido',
                status: err.response?.status || 'N/A',
                data: err.response?.data || null
            });
            toast.error(`❌ Error: ${err.message || 'Error al ejecutar la petición'}`);
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success('📋 Copiado al portapapeles');
    };

    return (
        <div className="api-tester-container">
            <div className="api-tester-header">
                <h2>🔧 Probador de APIs</h2>
                <p>Ejecuta métodos GET de las APIs del backend de forma simple</p>
            </div>

            <div className="api-tester-content">
                {/* Panel izquierdo: Lista de endpoints */}
                <div className="endpoints-panel">
                    <div className="search-box">
                        <input
                            type="text"
                            placeholder="🔍 Buscar endpoint..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                        />
                        <div className="endpoints-count">
                            {filteredEndpoints.length} endpoint{filteredEndpoints.length !== 1 ? 's' : ''} disponible{filteredEndpoints.length !== 1 ? 's' : ''}
                        </div>
                    </div>

                    <div className="endpoints-list">
                        {filteredEndpoints.length > 0 ? (
                            filteredEndpoints.map((endpoint, index) => (
                                <div
                                    key={index}
                                    className={`endpoint-item ${selectedEndpoint === endpoint ? 'selected' : ''}`}
                                    onClick={() => handleEndpointSelect(endpoint)}
                                >
                                    <div className="endpoint-name">{endpoint.name}</div>
                                    <div className="endpoint-service">{endpoint.service}</div>
                                    <div className="endpoint-description">{endpoint.description}</div>
                                </div>
                            ))
                        ) : (
                            <div className="no-results">
                                <div className="no-results-icon">🔍</div>
                                <p>No se encontraron endpoints</p>
                                <small>Intenta con otros términos de búsqueda</small>
                            </div>
                        )}
                    </div>
                </div>

                {/* Panel derecho: Detalles y ejecución */}
                <div className="execution-panel">
                    {selectedEndpoint ? (
                        <>
                            <div className="endpoint-details">
                                <h3>{selectedEndpoint.name}</h3>
                                <p className="detail-description">{selectedEndpoint.description}</p>
                                <div className="detail-meta">
                                    <span className="meta-tag">Servicio: {selectedEndpoint.service}</span>
                                    <span className="meta-tag">Método: {selectedEndpoint.method}</span>
                                </div>
                            </div>

                            {/* Formulario de parámetros */}
                            {selectedEndpoint.params.length > 0 && (
                                <div className="params-form">
                                    <h4>📝 Parámetros</h4>
                                    {selectedEndpoint.params.map((param, idx) => (
                                        <div key={idx} className="param-field">
                                            <label>{param.name}</label>
                                            {param.type === 'select' ? (
                                                <select
                                                    value={paramValues[param.name] || ''}
                                                    onChange={(e) => handleParamChange(param.name, e.target.value)}
                                                    className="param-input"
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {param.options.map(opt => (
                                                        <option key={opt} value={opt}>{opt}</option>
                                                    ))}
                                                </select>
                                            ) : param.type === 'json' ? (
                                                <textarea
                                                    placeholder={param.placeholder}
                                                    value={typeof paramValues[param.name] === 'object'
                                                        ? JSON.stringify(paramValues[param.name], null, 2)
                                                        : paramValues[param.name] || ''}
                                                    onChange={(e) => handleParamChange(param.name, e.target.value)}
                                                    className="param-input param-textarea"
                                                    rows={6}
                                                />
                                            ) : (
                                                <input
                                                    type={param.type}
                                                    placeholder={param.placeholder}
                                                    value={paramValues[param.name] || ''}
                                                    onChange={(e) => handleParamChange(param.name, e.target.value)}
                                                    className="param-input"
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Botón ejecutar */}
                            <button
                                onClick={executeEndpoint}
                                disabled={loading}
                                className="execute-button"
                            >
                                {loading ? '⏳ Ejecutando...' : '▶️ Ejecutar'}
                            </button>

                            {/* Respuesta */}
                            {(response || error) && (
                                <div className="response-container">
                                    <div className="response-header">
                                        <h4>{error ? '❌ Error' : '✅ Respuesta'}</h4>
                                        <button
                                            onClick={() => copyToClipboard(JSON.stringify(error || response, null, 2))}
                                            className="copy-button"
                                        >
                                            📋 Copiar
                                        </button>
                                    </div>
                                    <pre className={`response-body ${error ? 'error' : 'success'}`}>
                                        {JSON.stringify(error || response, null, 2)}
                                    </pre>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="apit-no-selection">
                            <div className="apit-no-selection-icon">🔍</div>
                            <h3>Bienvenido al Probador de APIs</h3>
                            <p>Selecciona un endpoint de la lista para comenzar</p>
                            <div className="help-section">
                                <h4>📖 ¿Cómo funciona?</h4>
                                <ol>
                                    <li>🔍 Busca el endpoint que necesitas probar</li>
                                    <li>📋 Completa los parámetros requeridos (si los hay)</li>
                                    <li>▶️ Haz clic en "Ejecutar" para llamar al backend</li>
                                    <li>✅ Analiza la respuesta en formato JSON</li>
                                </ol>
                                <div className="help-tip">
                                    💡 <strong>Tip:</strong> Usa el buscador para encontrar rápidamente lo que necesitas
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApiTester;

